import { BaseEntity } from "./BaseEntity";
import { Company } from "./Company";
import { InternshipSchedule } from "./InternshipSchedule";
import { School } from "./School";
import { User } from "./User";
import { Message } from "./Message";

export class MessageThread extends BaseEntity {
    public name?: string = "";
    public messageThreadType?: string = "";
    public user?: string | User = "";
    public members?: string[] | User[] = [];
    public internshipSchedule?: string | InternshipSchedule = "";
    public isArchive?: boolean = false;
    public messages?: string[] | Message[] = [];
    public school?: string | School = "";
    public company?: string | Company = "";

    constructor(model: Partial<MessageThread> = {}) {
        super(model?.id);
        Object.assign(this, model);
    }
}

export type PMessageThread = Partial<MessageThread>;
